import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, AuthContext } from './context/AuthContext';
import { LanguageCurrencyProvider } from './context/LanguageCurrencyContext';
import './i18n/config'; // Initialize i18n
import RoleBasedRoute from './components/RoleBasedRoute';
import ScrollToTop from './components/ScrollToTop';
import ScrollToTopButton from './components/ScrollToTopButton';
import WhatsAppButton from './components/WhatsAppButton';
import Home from './pages/Home';
import About from './pages/About';
import TouringGuide from './pages/TouringGuide';
import Contact from './pages/Contact';
import Properties from './pages/Properties';
import PropertyDetail from './pages/PropertyDetail';
import Booking from './pages/Booking';
import BookingDetails from './pages/BookingDetails';
import StayDetails from './pages/StayDetails';
import Login from './pages/Login';
import Register from './pages/Register';
import VerifyEmail from './pages/VerifyEmail';
import RegisterOwner from './pages/RegisterOwner';
import ExclusiveOffers from './pages/ExclusiveOffers';
import Terms from './pages/Terms';
import TermsClient from './pages/TermsClient';
import TermsOwner from './pages/TermsOwner';
import SuperAdminDashboard from './pages/dashboards/SuperAdminDashboard';
import AdminDashboard from './pages/dashboards/AdminDashboard';
import OperationsDashboard from './pages/dashboards/OperationsDashboard';
import PropertyOwnerDashboard from './pages/dashboards/PropertyOwnerDashboard';
import ClientDashboard from './pages/dashboards/ClientDashboard';
import HousekeepingDashboard from './pages/dashboards/HousekeepingDashboard';
import './App.css';

const AppRoutes = () => {
  const { user, getDashboardPath } = useContext(AuthContext);

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/touring-guide" element={<TouringGuide />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/properties" element={<Properties />} />
      <Route path="/properties/:id" element={<PropertyDetail />} />
      <Route path="/exclusive-offers" element={<ExclusiveOffers />} />
      <Route path="/booking" element={<Booking />} />
      <Route path="/client/booking/:id" element={<BookingDetails />} />
      <Route path="/client/booking/:id/stay-details" element={<StayDetails />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/terms/client" element={<TermsClient />} />
      <Route path="/terms/owner" element={<TermsOwner />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/verify-email/:token" element={<VerifyEmail />} />
      <Route path="/register-owner" element={<RegisterOwner />} />
      <Route
        path="/super-admin"
        element={
          <RoleBasedRoute allowedRoles={['super_admin']}>
            <SuperAdminDashboard />
          </RoleBasedRoute>
        }
      />
      <Route
        path="/admin"
        element={
          <RoleBasedRoute allowedRoles={['admin', 'super_admin']}>
            <AdminDashboard />
          </RoleBasedRoute>
        }
      />
      <Route
        path="/operations"
        element={
          <RoleBasedRoute allowedRoles={['operations']}>
            <OperationsDashboard />
          </RoleBasedRoute>
        }
      />
      <Route
        path="/owner"
        element={
          <RoleBasedRoute allowedRoles={['property_owner']}>
            <PropertyOwnerDashboard />
          </RoleBasedRoute>
        }
      />
      <Route
        path="/client"
        element={
          <RoleBasedRoute allowedRoles={['client']}>
            <ClientDashboard />
          </RoleBasedRoute>
        }
      />
      <Route
        path="/housekeeping"
        element={
          <RoleBasedRoute allowedRoles={['housekeeping']}>
            <HousekeepingDashboard />
          </RoleBasedRoute>
        }
      />
    </Routes>
  );
};

function App() {
  return (
    <LanguageCurrencyProvider>
      <AuthProvider>
        <Router>
          <ScrollToTop />
          <div className="App">
            <AppRoutes />
          </div>
          {/* Scroll-to-top button - appears when user scrolls down */}
          <ScrollToTopButton />
          {/* WhatsApp Button - Appears on all pages, fixed position */}
          <WhatsAppButton phoneNumber="+966568885544" message="Hello! I'm interested in viewing your properties." />
        </Router>
      </AuthProvider>
    </LanguageCurrencyProvider>
  );
}

export default App;
